import React from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { CButton } from '@coreui/react';

/**
 * Renders the calendar popover overlay.
 */
const DateRangePopover = ({ selectedRange, onSelectionChange, minDate, maxDate, staticRanges, onClose }) => (
  <div
    style={{
      position: 'absolute',
      top: '100%',
      left: 0,
      zIndex: 9999,
      backgroundColor: '#fff',
      boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
      borderRadius: '8px',
      padding: '12px',
      marginTop: '6px',
    }}
  >
    <DateRangePicker
      ranges={selectedRange}
      onChange={onSelectionChange}
      minDate={minDate}
      maxDate={maxDate}
      staticRanges={staticRanges}
      showSelectionPreview={true}
      moveRangeOnFirstSelection={false}
      editableDateInputs={true}
      direction="horizontal"
      preventSnapRefocus={true}
    />
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
      <CButton color="aimhi-textlight-neutral" size="sm" onClick={onClose}>
        Done
      </CButton>
    </div>
  </div>
);

export default DateRangePopover;
